import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import getDecodeDescription from "../../services/decodeText";
import {
  setIsLoading,
  getOneNewsByKey,
  setNewsToEdit,
} from "../../reduxSetup/action";
import { addNewsAPI } from "../../services/api";
import {
  checkIsValidForm,
  updateErrorsForm,
} from "../../services/manageValidation";
import {
  getSelected,
  getButtonText,
  handleFieldChange,
} from "../../services/filters";
import { TextField } from "../../components/TextField/TextField";
import DropDown from "../../containers/DropDown/DropDown";
import { ModalConsumer } from "../../common/ModalContext";
import ModalAdditionResult from "../../components/ModalAdditionResult/ModalAdditionResult";
import FormGetItemByKey from "../../components/FormGetItemByKey/FormGetItemByKey";
import COUNTRIES from "../../constants/countries";
import FIELDS_NEWS from "../../constants/news";
import styles from "./AddNews.module.scss";
import cx from "classnames";
import { validateURL } from "../../services/validateURL";
import { Button } from "reactstrap";
import ModalWithDropDown from "../../components/ModalWithDropDown/ModalWithDropDown";
import { getSearchOptions } from "../../services/getSearchOptions";

const initialState = {
  title: "",
  body: "",
  photo: "",
  photoSource: "",
  source: "",
  titleSeo: "",
  descriptionSeo: "",
  countries: [],
  newsFields: [],
};

const AddNews = ({
  setIsLoading,
  email,
  role,
  getOneNewsByKey,
  setNewsToEdit,
  newsToEdit,
}) => {
  const [state, setState] = useState(initialState);
  const [validationError, setValidationError] = useState([]);
  const [newsKey, setNewsKey] = useState("");

  useEffect(() => {
    if (!newsToEdit || !newsToEdit.length) {
      return;
    }
    const oneNewsToEdit = newsToEdit[0];
    setState((newsData) => ({
      ...newsData,
      title: oneNewsToEdit?.title,
      countries: [oneNewsToEdit?.country],
      newsFields: [oneNewsToEdit?.field],
      body: getDecodeDescription(oneNewsToEdit?.body),
      photo: oneNewsToEdit?.photo,
      source: oneNewsToEdit?.source,
      photoSource: oneNewsToEdit?.photoSource,
      titleSeo: oneNewsToEdit?.titleSeo,
      descriptionSeo: oneNewsToEdit?.descriptionSeo,
      key: oneNewsToEdit?.key,
      date: oneNewsToEdit?.date,
    }));
  }, [newsToEdit]);

  const handleSubmit = async ({ event, toggleModal }) => {
    event.preventDefault();
    const data = { ...state };

    data.type = "news";

    if (!checkIsValidForm({ state: data })) {
      updateErrorsForm({ state: data, setValidationError });
      return;
    }
    addNews(toggleModal);
  };

  const addNews = async (toggleModal) => {
    setIsLoading(true);
    try {
      const response = await addNewsAPI({
        article: {
          title: state.title,
          body: encodeURIComponent(state.body),
          photo: state.photo,
          author: email,
          source: state.source,
          photoSource: state.photoSource,
          titleSeo: state.titleSeo,
          descriptionSeo: state.descriptionSeo,
          field: state.newsFields[0],
          country: state.countries[0],
          key: state.key,
          status: role === "content_manager" ? "pending_review" : "published",
          date: state?.date,
        },
        userRole: role,
      });
      if (!response || response.status !== 200) {
        throw new Error("Something went wrong");
        // setError()
      }

      clearAll();
      setNewsKey("");
      toggleModal();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const clearAll = () => {
    setState(initialState);
    setNewsToEdit(false);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setState((state) => ({
      ...state,
      [name]: value,
    }));

    if (name === "photo" || name === "source") {
      validateURL(value) &&
        cancelValidationError(name, setValidationError, validationError);
    } else {
      value.length &&
        cancelValidationError(name, setValidationError, validationError);
    }
  };

  const dropDownSelect = (value, name) => {
    setState((state) => ({
      ...state,
      [name]: [value],
    }));
    value.length &&
      cancelValidationError(name, setValidationError, validationError);
  };
  const getChangeValue = (modalId, value) => {
    switch (modalId) {
      case "countries":
        setState((prev) => ({ ...prev, countries: value }));
        break;
      case "newsFields":
        setState((prev) => ({ ...prev, newsFields: value }));
        break;
    }
  };
  const checkTitleLength = (e) => {
    if (e.target.value.length > 50) {
      return;
    }
    handleChange(e);
  };
  const cancelValidationError = (filterType) => {
    // MOVE TO SERVICES?
    setValidationError(
      validationError.filter((errorItem) => errorItem !== filterType)
    );
  };
  const changeValidationError = (filterType) => {
    // MOVE TO SERVICES?
    setValidationError(
      validationError.filter((errorItem) => errorItem !== filterType)
    );
  };

  return (
    <div className={styles.addNew}>
      <h1 className={styles.addNewTitle}>Add News</h1>
      <FormGetItemByKey
        itemKey={newsKey}
        type="news"
        setItemKey={setNewsKey}
        getItemToEdit={getOneNewsByKey}
      />

      <ModalConsumer>
        {({ isOpen, toggleModal }) => (
          <>
            <ModalAdditionResult
              toggleModal={toggleModal}
              isOpen={isOpen}
              content="You've added a news"
            />
            <form
              onSubmit={(event) => handleSubmit({ event, toggleModal })}
              className={styles.addNewForm}
            >
              <TextField
                label="Title*"
                placeholder="Title"
                name="title"
                handleChange={checkTitleLength}
                value={state.title}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("title"),
                })}
              />
              <p
                className={cx(styles.errorLabel, {
                  "d-block": validationError.includes("title"),
                })}
              >
                {("error", "Please, write title")}
              </p>
              <div className={styles.dropDownContainer}>
                <div className={cx(styles.dropDown, styles.dropDownDesktop)}>
                  <p className={styles.fieldLabel}>Country*</p>
                  <DropDown
                    name="countries"
                    changeValidationError={changeValidationError}
                    className={styles.autocomplete}
                    onChange={dropDownSelect}
                    selected={state.countries}
                    onClear={() => dropDownSelect([], "countries")}
                    dropDownErrorClass={
                      validationError.includes("countries") &&
                      styles.dropDownError
                    }
                    options={COUNTRIES}
                    buttonText={getButtonText(
                      state.countries,
                      "Countries",
                      "countries"
                    )}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("countries"),
                    })}
                  >
                    {("error", "Please, choose countries")}
                  </p>
                </div>
                <div className={cx(styles.dropDown, styles.dropDownDesktop)}>
                  <p className={styles.fieldLabel}>Fields*</p>
                  <DropDown
                    name="newsFields"
                    className={styles.autocomplete}
                    changeValidationError={changeValidationError}
                    onChange={dropDownSelect}
                    selected={state.newsFields}
                    onClear={() => dropDownSelect([], "newsFields")}
                    dropDownErrorClass={
                      validationError.includes("newsFields") &&
                      styles.dropDownError
                    }
                    options={FIELDS_NEWS}
                    buttonText={getButtonText(
                      state.newsFields,
                      "Fields",
                      "newsFields"
                    )}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("newsFields"),
                    })}
                  >
                    {("error", "Please, choose fields")}
                  </p>
                </div>
              </div>
              <div className={styles.dropDownMobile}>
                <ModalConsumer>
                  {({ toggleModal }) => (
                    <>
                      <p
                        className={cx(styles.fieldLabel, {
                          [styles.labelError]:
                            validationError.includes("countries"),
                        })}
                      >
                        Countries*
                      </p>
                      <Button
                        onClick={() => {
                          toggleModal("countries");
                        }}
                        className={cx(
                          styles.filterButton,
                          {
                            [styles.dropDownError]:
                              validationError.includes("countries"),
                          },
                          state.countries.length
                            ? styles.labelValue
                            : styles.labelName
                        )}
                      >
                        {getButtonText(
                          state.countries,
                          "Countries",
                          "countries"
                        )}
                      </Button>
                    </>
                  )}
                </ModalConsumer>
              </div>
              <div className={styles.dropDownMobile}>
                <ModalConsumer>
                  {({ toggleModal }) => (
                    <>
                      <p
                        className={cx(styles.fieldLabel, {
                          [styles.labelError]:
                            validationError.includes("newsFields"),
                        })}
                      >
                        Fields*
                      </p>
                      <Button
                        onClick={() => {
                          toggleModal("newsFields");
                        }}
                        className={cx(
                          styles.filterButton,
                          {
                            [styles.dropDownError]:
                              validationError.includes("newsFields"),
                          },
                          state.newsFields.length
                            ? styles.labelValue
                            : styles.labelName
                        )}
                      >
                        {getButtonText(
                          state.newsFields,
                          "Fields",
                          "newsFields"
                        )}
                      </Button>
                    </>
                  )}
                </ModalConsumer>
              </div>
              <TextField
                label="Body*"
                placeholder="Body"
                name="body"
                handleChange={handleChange}
                value={state.body}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("body"),
                })}
              />
              <p
                className={cx(styles.errorLabel, {
                  "d-block": validationError.includes("body"),
                })}
              >
                {("error", "Please, write body")}
              </p>
              <TextField
                label="Photo URL*"
                placeholder="Photo URL"
                name="photo"
                handleChange={handleChange}
                value={state.photo}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("photo"),
                })}
              />
              <p
                className={cx(styles.errorLabel, {
                  "d-block": validationError.includes("photo"),
                })}
              >
                {("error", "Please, write photo (valid URL)")}
              </p>
              <TextField
                label="Photo Source Domain name*"
                placeholder="Photo Source Domain Name"
                name="photoSource"
                handleChange={handleChange}
                value={state.photoSource}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("photoSource"),
                })}
              />

              <TextField
                label="Source URL*"
                placeholder="Source URL"
                name="source"
                handleChange={handleChange}
                value={state.source}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("source"),
                })}
              />
              <p
                className={cx(styles.errorLabel, {
                  "d-block": validationError.includes("source"),
                })}
              >
                {("error", "Please, write source (valid URL)")}
              </p>
              <p className={styles.title}>SEO</p>
              <div className={cx(styles.formItem)}>
                <TextField
                  name="titleSeo"
                  placeholder="Title SEO"
                  value={state.titleSeo}
                  handleChange={handleChange}
                  isTextArea
                />
              </div>
              <div className={styles.textareaContainer}>
                <TextField
                  type="textarea"
                  name="descriptionSeo"
                  placeholder="Description SEO"
                  handleChange={handleChange}
                  value={state.descriptionSeo}
                  isTextArea
                />
              </div>
              <div className={styles.addNewButtonContainer}>
                <button
                  className={styles.addNewButton + " " + styles.addNewButtonAdd}
                  type="submit"
                >
                  Add
                </button>
                <button
                  onClick={clearAll}
                  className={
                    styles.addNewButton + " " + styles.addNewButtonClear
                  }
                  type="button"
                >
                  Clear All
                </button>
              </div>
            </form>
          </>
        )}
      </ModalConsumer>
      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            modalId === "countries" && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={COUNTRIES}
                selected={getSelected({
                  modalId,
                  countries: state.countries,
                })}
                onChange={handleFieldChange.bind({
                  filter: modalId,
                  changeFilter: (value) => getChangeValue(modalId, value),
                  selected: getSelected({
                    modalId,
                    countries: state.countries,
                  }),
                  cancelValidationError: cancelValidationError,
                })}
                onClear={() => getChangeValue(modalId, [])}
                changeValidationError={changeValidationError}
              />
            )
          );
        }}
      </ModalConsumer>
      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            modalId === "newsFields" && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={getSearchOptions(modalId)}
                selected={getSelected({
                  modalId,
                  newsFields: state.newsFields,
                })}
                onChange={handleFieldChange.bind({
                  filter: modalId,
                  changeFilter: (value) => getChangeValue(modalId, value),
                  selected: getSelected({
                    modalId,
                    newsFields: state.newsFields,
                  }),
                  cancelValidationError: cancelValidationError,
                })}
                onClear={() => getChangeValue(modalId, [])}
                changeValidationError={changeValidationError}
              />
            )
          );
        }}
      </ModalConsumer>
    </div>
  );
};

AddNews.propTypes = {
  updateIsLoading: PropTypes.func,
  email: PropTypes.string,
};

const mapDispatchToProps = {
  setIsLoading,
  getOneNewsByKey,
  setNewsToEdit,
};

const mapStateToProps = ({ news, user: { email, role } }) => {
  const { newsToEdit } = news;
  return {
    newsToEdit,
    email,
    role,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddNews);
